export interface Permission {
  id: number;
  isCreate: boolean;
  isDelete: boolean;
  isRead: boolean;
  isUpdate: boolean;
  moduleId: number;
  moduleName: keyof PermissionsParsed;
  roleId: string;
}

export interface PermissionsParsed {
  "BOL COUNTIES"?: Permission;
  "BOL MARKETS"?: Permission;
  "REFINERY ADDRESSES"?: Permission;
  BATORDERS?: Permission;
  BOLCHKBXENTEREDINTOQB?: Permission;
  BOLCHKBXPAID?: Permission;
  BOLCHKBXPRICECHECK?: Permission;
  BOLCHKBXREJECTED?: Permission;
  BOLCHKBXTAXCHECK?: Permission;
  BOLCHKRECEIVEDBOLALLOWED?: Permission;
  BOLCHKRECEIVEDINVOICE?: Permission;
  BOLS?: Permission;
  CARRIERS?: Permission;
  CategoryTax?: Permission;
  CustomerLog?: Permission;
  CustomersPage?: Permission;
  DashboardPage?: Permission;
  DriversPage?: Permission;
  JobTypes?: Permission;
  JobTypeGroups?: Permission;
  LOADORIGIN?: Permission;
  LUBEORDERS?: Permission;
  LUBETICKETS?: Permission;
  MapPage?: Permission;
  MarketTaxes?: Permission;
  Markets?: Permission;
  OrdersLog?: Permission;
  OrdersPage?: Permission;
  OrdersTicketsChangeLog?: Permission;
  OrderBulkUpload?: Permission;
  PRICES?: Permission;
  PageModules?: Permission;
  PageNotAccess?: Permission;
  PaymentTerms?: Permission;
  Permissions?: Permission;
  ProductCategories?: Permission;
  ProductsPage?: Permission;
  REFINERIES?: Permission;
  RigLog?: Permission;
  Rigs?: Permission;
  Roles?: Permission;
  SalesReps?: Permission;
  SettingsList?: Permission;
  ShippingPapers?: Permission;
  ShippingPapersPage?: Permission;
  TERMINALS?: Permission;
  TRUCKS?: Permission;
  Taxes?: Permission;
  TicketAdminPage?: Permission;
  TicketLog?: Permission;
  TicketPapersPage?: Permission;
  TicketSearchPage?: Permission;
  TicketsPage?: Permission;
  TktsChkBxApprovedBilling?: Permission;
  TktsChkBxBillingRejected?: Permission;
  TktsChkBxInvoiced?: Permission;
  TktsChkBxMissingTkt?: Permission;
  TruckPage?: Permission;
  Units?: Permission;
  Users?: Permission;
  VENDORS?: Permission;
  Wells?: Permission;
}

export const initialStatePermissions: PermissionsParsed = {
  "BOL COUNTIES": undefined,
  "BOL MARKETS": undefined,
  "REFINERY ADDRESSES": undefined,
  BATORDERS: undefined,
  BOLCHKBXENTEREDINTOQB: undefined,
  BOLCHKBXPAID: undefined,
  BOLCHKBXPRICECHECK: undefined,
  BOLCHKBXREJECTED: undefined,
  BOLCHKBXTAXCHECK: undefined,
  BOLCHKRECEIVEDBOLALLOWED: undefined,
  BOLCHKRECEIVEDINVOICE: undefined,
  BOLS: undefined,
  CARRIERS: undefined,
  CategoryTax: undefined,
  CustomerLog: undefined,
  CustomersPage: undefined,
  DashboardPage: undefined,
  DriversPage: undefined,
  JobTypes: undefined,
  JobTypeGroups: undefined,
  LOADORIGIN: undefined,
  LUBEORDERS: undefined,
  LUBETICKETS: undefined,
  MapPage: undefined,
  MarketTaxes: undefined,
  Markets: undefined,
  OrdersLog: undefined,
  OrderBulkUpload: undefined,
  OrdersPage: undefined,
  OrdersTicketsChangeLog: undefined,
  PRICES: undefined,
  PageModules: undefined,
  PageNotAccess: undefined,
  PaymentTerms: undefined,
  Permissions: undefined,
  ProductCategories: undefined,
  ProductsPage: undefined,
  REFINERIES: undefined,
  RigLog: undefined,
  Rigs: undefined,
  Roles: undefined,
  SalesReps: undefined,
  SettingsList: undefined,
  ShippingPapers: undefined,
  ShippingPapersPage: undefined,
  TERMINALS: undefined,
  TRUCKS: undefined,
  Taxes: undefined,
  TicketAdminPage: undefined,
  TicketLog: undefined,
  TicketPapersPage: undefined,
  TicketSearchPage: undefined,
  TicketsPage: undefined,
  TktsChkBxApprovedBilling: undefined,
  TktsChkBxBillingRejected: undefined,
  TktsChkBxInvoiced: undefined,
  TktsChkBxMissingTkt: undefined,
  TruckPage: undefined,
  Units: undefined,
  Users: undefined,
  VENDORS: undefined,
  Wells: undefined,
};

export interface PagePermissions {
  isCreate?: Permission["isCreate"];
  isDelete?: Permission["isDelete"];
  isRead?: Permission["isRead"];
  isUpdate?: Permission["isUpdate"];
}

export interface Module {
  id: number;
  isEnabled: boolean;
  moduleName: string;
  normalizedName: string;
}

export interface RolePermissions {
  Id: number;
  IsCreate: boolean;
  IsDelete: boolean;
  IsRead: boolean;
  IsUpdate: boolean;
  ModuleId: number;
  ModuleName: string;
  RoleId: string;
}

export type PutRolePermissions = Omit<RolePermissions, "ModuleName">;
